module.exports = __webpack_public_path__ + "media/images/landing__teaser__bg-b5ed0ef73695e6ed82e7bf0062ec0361.jpg";